import styled from 'styled-components';
import { commonStyles } from './commonStyles';
export var SquareImageBlock = styled.div.withConfig({
  displayName: "SquareImageBlock",
  componentId: "sc-1m6wqz1-0"
})(["", ";img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}"], commonStyles);